import {runTokenIntents} from '../token';
import {Priority} from './constants';
import {runElementTransforms} from './element';
import {addIntentsToRevision} from './ViewRevision';
import type {View} from './types';
import {runLazyStyleIntents} from '../style/StyleIntent';
import type {CssPolicy} from '../providers/EngineConfigProvider';

export function runDomIntents<
  Props,
  Options extends View.ConfigOptions = never,
>(
  revision: View.ViewRevision<Props>,
  options: Options,
  cssPolicy?: CssPolicy,
): void {
  addIntentsToRevision(
    revision,
    runTokenIntents(revision, cssPolicy),
    Priority.Normal,
  );

  runElementTransforms(revision);
  runLazyStyleIntents(revision, options, cssPolicy);
}
